<ng-container
  [appTransition]="child"
  [show]="active"
  [duration]="200"
  enter="transition-all"
  enterFrom="opacity-0"
  enterTo="opacity-100"
  leave="transition-all"
  leaveFrom="opacity-100"
  leaveTo="opacity-0"
>
  <div #child class="selector">
    <app-container>
      <div class="content">
        <div class="header">
          <h2>Selecione um serviço</h2>
          <button (click)="closed.emit()">
            <span class="pi pi-times"></span>
          </button>
        </div>
        <div class="services">
          <div class="services-list">
            <div class="services-table">
              <p-table
                [value]="paginatedServices()"
                [tableStyle]="{ 'min-width': '50rem' }"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th scope="col">Serviço</th>
                    <th scope="col">CNAE</th>
                    <th scope="col">Código do serviço</th>
                    <th scope="col">Cód. tributação</th>
                    <th scope="col">NBS</th>
                    <th scope="col"></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-service>
                  <tr>
                    <td class="descricao" [title]="service.discriminacao || ''">
                      {{ service.nome || service.discriminacao || "—" }}
                    </td>
                    <td class="codigo">{{ formatarCnae(service.cnae) || "—" }}</td>
                    <td class="codigo">
                      {{ formatarItemLc116(service.codigo) || "—" }}
                    </td>
                    <td class="codigo">{{ service.codigoTributacao || "—" }}</td>
                    <td class="codigo">{{ service.codigoNbs || "—" }}</td>
                    <td class="button">
                      <app-button
                        type="button"
                        (click)="select(service)"
                        (keydown.enter)="select(service)"
                        text="Selecionar"
                      ></app-button>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
            <div class="services-card">
              <app-service-mobile-card
                [service]="service"
                (choose)="select(service)"
                *ngFor="let service of paginatedServices()"
              ></app-service-mobile-card>
            </div>
          </div>
          <div class="pagination">
            <p-paginator
              (onPageChange)="onPageChange($event)"
              [first]="(currentPage() - 1) * itemsPerPage"
              [rows]="itemsPerPage"
              [totalRecords]="totalServices()"
            ></p-paginator>
          </div>
        </div>
      </div>
    </app-container>
  </div>
</ng-container>
